<div class="contactus-container">
  <div class="contactus-content">

    <!-- ── Header ── -->
    <div class="list-header">
      <h5>List of Lex-Z Client Inquiries <span *ngIf="!isLoading && dataSource.length > 0" class="leads-count-badge">{{ dataSource.length }}</span></h5>

      <div class="list-actions">

        <!-- Search Box -->
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border: 0px !important">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              style="padding: 0px !important; border: 0px !important"
              placeholder="Search by name, email, phone..."
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()">
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor:pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>

        <!-- Reload Button -->
        <button class="btn clear-filter-btn" (click)="loadLeads()">
          <i class="bi bi-arrow-clockwise me-1"></i> Reload
        </button>

      </div>
    </div>

    <!-- ── Table ── -->
    <div class="leads-table" [class.loading]="isLoading"
         *ngIf="!isLoading && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <!-- 1. Name -->
            <th class="thdata sortable-col" scope="col" (click)="sortBy('firmname')">
              Name <i class="bi sort-icon" [ngClass]="getSortIcon('firmname')"></i>
            </th>
            <!-- 2. Issue -->
            <th class="thdata hide-lg" scope="col">Issue</th>
            <!-- 3. Email -->
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <!-- 4. Phone -->
            <th class="thdata hide-md" scope="col">Phone</th>
            <!-- 5. Location -->
            <th class="thdata hide-lg" scope="col">Location</th>
            <!-- 6. Inquired On -->
            <th class="thdata sortable-col" scope="col" (click)="sortBy('createdAt')">
              Inquired On <i class="bi sort-icon" [ngClass]="getSortIcon('createdAt')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lead of getPage()">

            <!-- 1. Name -->
            <td>
              <div class="firm-name">
                <!-- <span class="firm-avatar">{{ getInitials(lead.firmname) }}</span> -->
                <span>{{ lead.firmname || '-' }}</span>
              </div>
            </td>

            <!-- 2. Issue -->
            <td class="hide-lg message-cell">{{ lead.issue || '-' }}</td>

            <!-- 3. Email -->
            <td class="hide-md email-cell">
              <a *ngIf="lead.email" [href]="'mailto:' + lead.email" class="email-link">
                {{ lead.email }}
              </a>
              <span *ngIf="!lead.email">-</span>
            </td>

            <!-- 4. Phone -->
            <td class="hide-md">{{ lead.phone || '-' }}</td>

            <!-- 5. Location -->
            <td class="hide-lg">{{ lead.city || '-' }}</td>

            <!-- 6. Inquired On -->
            <td>{{ lead.createdAt || '-' }}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Skeleton loader ── -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-cell avatar-cell"></div>
        <div class="skeleton-cell wide hide-lg"></div>
        <div class="skeleton-cell wide hide-md"></div>
        <div class="skeleton-cell medium hide-md"></div>
        <div class="skeleton-cell short hide-lg"></div>
        <div class="skeleton-cell medium"></div>
      </div>
    </div>

    <!-- ── Empty state ── -->
    <div *ngIf="!isLoading && dataSource.length === 0" class="empty-state">
      <i class="bi bi-inbox empty-icon"></i>
      <p class="empty-title">No Leads Found</p>
      <p class="empty-sub">
        {{ searchQuery ? 'No results match your search.' : 'No leads available for Lex-Z Client.' }}
      </p>
    </div>

    <!-- ── Pagination ── -->
    <div class="pagination-area" *ngIf="!isLoading && dataSource.length > 0">
      <div class="pagination-info">{{ getPaginationRange() }}</div>
      <nav aria-label="Leads pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
              <i class="bi bi-chevron-double-left biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
              <i class="bi bi-chevron-left biarr"></i> Previous
            </a>
          </li>
          <li *ngFor="let page of getPageNumbers()" class="page-item"
              [ngClass]="{'active': page === pageIndex + 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPage(page - 1)">{{ page }}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
              Next <i class="bi bi-chevron-right biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
              <i class="bi bi-chevron-double-right biarr"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>